import { useEffect, useState } from "react";
import { PARTNER_IDS } from "@chef/constants";
import { Input } from "@chef/components";
import { useAppDispatch, useAppSelector } from "@chef/state-management/hooks";
import { language } from "@chef/constants";
import { getPartnership, setPartnership } from "@chef/state-management";

const intl = {
  no: {
    EUROBONUS_NUMBER: "Eurobonus-nummer",
  },
  se: {
    EUROBONUS_NUMBER: "Eurobonus-nummer",
  },
  dk: {
    EUROBONUS_NUMBER: "Eurobonus-nummer",
  },
};

export const EurobonusComponent = () => {
  const dispatch = useAppDispatch();
  const eurobonusPartnership = useAppSelector((state) =>
    getPartnership(state.signupRtk.partnerships, PARTNER_IDS.EUROBONUS),
  );
  const [eurobonusNumber, _setEurobonusNumber] = useState("");
  const EUROBONUS_NUMBER_LENGTH = 9;

  const setEurobonusNumber = (value: string) => {
    const numericValue = value.replace(/[^0-9]/g, "");
    _setEurobonusNumber(numericValue);
  };

  useEffect(() => {
    if (eurobonusNumber.length === EUROBONUS_NUMBER_LENGTH) {
      dispatch(
        setPartnership({
          partnerId: PARTNER_IDS.EUROBONUS,
          customerReference: eurobonusNumber,
        }),
      );
    }
  }, [eurobonusNumber, dispatch]);

  return (
    <Input
      placeholder={intl[language].EUROBONUS_NUMBER}
      name="eurobonusNumber"
      id="eurobonusNumber"
      value={eurobonusNumber}
      onChange={(e) => setEurobonusNumber(e.target.value)}
      showLengthCounter
      maxLength={EUROBONUS_NUMBER_LENGTH}
      valid={!!eurobonusPartnership}
    />
  );
};
